(() => {
  let currentMood='all';
  function filterEdit(mood) {
    mood=['all','solo','together','rituals'].includes(mood)?mood:'all';currentMood=mood;
    const edit = document.querySelector('#reference-edit');
    if (!edit) return;
    edit.querySelectorAll('[data-reference-category]').forEach(card => {const query=(document.querySelector('[data-reference-query]')?.value||'').toLowerCase().trim();card.hidden=(mood !== 'all' && card.dataset.referenceCategory !== mood)||!(card.dataset.referenceKeywords||card.textContent).toLowerCase().includes(query);});
    edit.querySelectorAll('[data-reference-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.referenceFilter === mood)));
    const count = edit.querySelector('[data-reference-count]');
    const total=edit.querySelectorAll('[data-reference-category]:not([hidden])').length;
    if(count)count.textContent=total;
    const empty=edit.querySelector('[data-reference-empty]');if(empty)empty.hidden=total>0;
  }
  document.addEventListener('click', event => {
    const filter = event.target.closest('[data-reference-filter], [data-edit-filter]');
    if (filter) filterEdit(filter.dataset.referenceFilter || filter.dataset.editFilter);
    const opener = event.target.closest('[data-reference-open], [data-dialog-open]');
    if (opener) document.getElementById((opener.dataset.referenceOpen||opener.dataset.dialogOpen))?.showModal();
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) closer.closest('dialog')?.close();
    const mobileLink = event.target.closest('.mobile-menu a');
    if (mobileLink) mobileLink.closest('details').open = false;
  });
  document.addEventListener('keydown', event => {if(event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => {menu.open=false;menu.querySelector('summary').focus();});});
  document.querySelector('[data-reference-query]')?.addEventListener('input',()=>filterEdit(currentMood));
  filterEdit(new URLSearchParams(location.search).get('edit')||'all');
})();
